export default __webpack_public_path__ + "static/media/hma-logo.a5991fec.png";